import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import metadataReducer from './slices/metadataSlice';
import userReducer from './slices/userSlice';
import authReducer from './slices/authSlice';
import paymentReducer from './slices/paymentSlice';
import quizReducer from './slices/quizSlice';
import formDataReducer from './slices/formDataSlice';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    metadata: metadataReducer,
    user: userReducer,
    auth: authReducer,
    payment: paymentReducer,
    quiz: quizReducer,
    formData: formDataReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types (modal callbacks are not serializable)
        ignoredActions: ['ui/openModal'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.onConfirm', 'payload.onCancel', 'payload.body'],
        // Ignore these paths in the state
        ignoredPaths: ['ui.modal.onConfirm', 'ui.modal.onCancel', 'ui.modal.body'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer types from the store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
